import classNames from 'classnames'
import { t } from 'i18next'
import { Dropdown } from 'primereact/dropdown'
import { InputText } from 'primereact/inputtext'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { apprenticeshipModuleTypes } from '../../../../../util/apprenticeshipModuleTypes'
import { getFormErrorMessage } from '../../../../util/ErrorText'

export const ModuleForm = () => {
  const { control } = useFormContext()

  return (
    <>
      <Controller
        control={control}
        name={'module_key'}
        rules={{ required: true, maxLength: 20 }}
        render={({
          field: { onChange, onBlur, value, name },
          fieldState: { error },
        }) => (
          <div className={'col'}>
            <label htmlFor={name}>
              {t<string>('grade_module.module.key')}*
            </label>
            <InputText
              id={name}
              maxLength={20}
              autoComplete={'off'}
              onChange={onChange}
              onBlur={onBlur}
              value={value || ''}
              placeholder={'105'}
              className={classNames({ 'p-invalid': error }, ' w-full')}
            />
            {error && <small className="p-error">{error?.message}</small>}
          </div>
        )}
      />
      <Controller
        control={control}
        name={'description'}
        rules={{ maxLength: 500 }}
        render={({
          field: { onChange, onBlur, value, name },
          fieldState: { error },
          formState,
        }) => (
          <div className={'col-6'}>
            <label htmlFor={name}>
              {t<string>('grade_module.module.description')}{' '}
            </label>
            <InputText
              id={name}
              autoComplete={'off'}
              onChange={onChange}
              placeholder={t<string>('grade_module.module.description') + '...'}
              type={'string'}
              maxLength={500}
              onBlur={onBlur}
              value={value || ''}
              className={classNames({ 'p-invalid': error }, ' w-full')}
            />
            {getFormErrorMessage(formState.errors, name)}
          </div>
        )}
      />
      <Controller
        control={control}
        name={'id_apprenticeship_module_type'}
        rules={{ required: true }}
        render={({
          field: { onChange, onBlur, value, name },
          fieldState: { error },
        }) => (
          <div className={'col'}>
            <label htmlFor={name}>{t<string>('core.type')}*</label>
            <Dropdown
              id={name}
              options={apprenticeshipModuleTypes}
              onChange={onChange}
              onBlur={onBlur}
              value={value || ''}
              placeholder={t<string>('core.select')}
              className={classNames({ 'p-invalid': error }, ' w-full')}
            />
            {error && <small className="p-error">{error?.message}</small>}
          </div>
        )}
      />
      <Controller
        control={control}
        name={'version'}
        rules={{ required: true, maxLength: 20 }}
        render={({
          field: { onChange, onBlur, value, name },
          fieldState: { error },
          formState,
        }) => (
          <div className={'col'}>
            <label htmlFor={name}>
              {t<string>('grade_module.module.version')}*
            </label>
            <InputText
              id={name}
              maxLength={20}
              onChange={onChange}
              type={'string'}
              onBlur={onBlur}
              placeholder={'1.0'}
              value={value || ''}
              className={classNames({ 'p-invalid': error }, ' w-full')}
            />
            {getFormErrorMessage(formState.errors, name)}
          </div>
        )}
      />
      <Controller
        control={control}
        name={'bivo'}
        rules={{ maxLength: 20 }}
        render={({
          field: { onChange, onBlur, value, name },
          fieldState: { error },
          formState,
        }) => (
          <div className={'col'}>
            <label htmlFor={name}>
              {t<string>('grade_module.module.bivo')}
            </label>
            <InputText
              id={name}
              maxLength={20}
              onChange={onChange}
              placeholder={new Date().getFullYear().toString()}
              onBlur={onBlur}
              value={value || ''}
              className={classNames({ 'p-invalid': error }, ' w-full')}
            />
            {getFormErrorMessage(formState.errors, name)}
          </div>
        )}
      />
      <Controller
        control={control}
        name={'year_of_release'}
        rules={{
          maxLength: 11,
          validate: (v: number) => !v || (v > 0 && !v.toString().includes('.')),
        }}
        render={({
          field: { onChange, onBlur, value, name },
          fieldState: { error },
          formState,
        }) => (
          <div className={'col'}>
            <label htmlFor={name}>
              {t<string>('grade_module.module.release_year')}
            </label>
            <InputText
              id={name}
              type={'number'}
              onChange={onChange}
              onBlur={onBlur}
              value={value || ''}
              className={classNames({ 'p-invalid': error }, ' w-full')}
              placeholder={new Date().getFullYear().toString()}
            />
            {getFormErrorMessage(formState.errors, name)}
          </div>
        )}
      />
    </>
  )
}